/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import React, { createContext, useContext } from 'react';
import { NavigationCallbacks } from '../../../purchases/src/actions/navigation';

export interface HomeNavigationContextType {
  navigateToProductTile: (redirectionUrl: string, productId: string) => void;
  navigateToNotificationBanner?: (actionUrl?: string) => void;
  profileHeaderActions?: ProfileHeaderActions;
  recommendationActions?: RecommendationActions;
  spotlightActions?: SpotlightActions;
  appNavigationCallbacks?: NavigationCallbacks;
}

export interface ProfileHeaderActions {
  navigateToSearch?: () => void;
  navigateToWallet?: () => void;
  navigateToAccount?: () => void;
}

export interface RecommendationActions {
  onCardPress?: (params: {
    itemId?: string;
    lob?: string;
    title?: string;
    deepLink?: string;
  }) => void;
  onPressCta?: (params: { deepLink?: string }) => void;
}

export interface SpotlightActions {
  onCardPress?: (cardId: string, redirectionUrl?: string) => void;
  navigateToMyTrips?: (redirectionUrl?: string) => void;
}

export const HomeNavigationContext = createContext<
  HomeNavigationContextType | undefined
>(undefined);

export const useHomeNavigation = (): HomeNavigationContextType => {
  const ctx = useContext(HomeNavigationContext);
  if (!ctx) {
    throw new Error(
      'useHomeNavigation must be used inside HomeNavigationContext.Provider',
    );
  }
  return ctx;
};
